import React from 'react';
import { withRouter } from 'react-router-dom';
import Component from 'BaseComponent';

@withRouter


export default class ConfirmationSent extends Component {

  render() {
    return (
      <div className="island">
        <div className="island__wrap">
          <a href="https://www.hardypress.com">
            <div className="island__title" />
          </a>
          <div className="island__content">
            <div className="island__content__title">
              Request sent!
              <br />
              We will get back to you shortly.
            </div>
            In the while you can give a look to
            our <a href="https://www.hardypress.com/docs/">DOCS</a> section to
            learn more about how HardyPress works.
          </div>
          <div className="island__footer">
            Many thanks for your patience :-)
          </div>
        </div>
      </div>
    );
    // return (
    //   <div className="island">
    //     <div className="island__wrap">
    //       <a href="https://www.hardypress.com">
    //         <div className="island__title" />
    //       </a>
    //       <div className="island__content">
    //         <div className="island__content__title">
    //           Check your email!
    //         </div>
    //         Thanks for signing up!
    //         A confirmation email has been sent to your email address,
    //         please check your inbox and click the confirmation link.
    //       </div>
    //       <div className="island__footer">
    //           Well done :-)
    //       </div>
    //     </div>
    //   </div>
    // );
  }
}



// WEBPACK FOOTER //
// ./app/components/ConfirmationSent.jsx